import { useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks'

import { useQuery } from '@tanstack/react-query'

import { getServicesQueryOptions } from './queries/getServicesQueryOptions'

export function useGetServices() {
  const { privacyCenterContent, isUSBranch, userSelectedEntity, userCountry } = useAppContext()
  const getServices = privacyCenterContent?.endpoints.services?.getServices

  const {
    data,
    status,
    isError: isServicesError,
    refetch,
  } = useQuery(
    getServicesQueryOptions({
      endpoint: getServices,
      userCountry,
      userSelectedEntity,
      isUSBranch,
    }),
  )

  const { services } = useMemo(() => {
    if (!data) return { services: [] }
    if (typeof data === 'string') return { services: [] }

    return { services: data }
  }, [data])

  const isServicesLoading = status === 'pending'

  return {
    services,
    isLoading: isServicesLoading,
    isServicesLoading,
    isServicesError,
    refetch,
  }
}
